export function isEmptyAfterDelete(params: {
  items: any[];
  totalItems: number;
  pageSize: number;
  currentPage: number;
}): boolean {
  const lastPage = Math.ceil(params.totalItems / params.pageSize);
  const lastPageItems = params.items.length % params.pageSize;

  return (
    params.currentPage !== 1 &&
    params.currentPage === lastPage &&
    lastPageItems === 1
  );
}
